import { createRequest, RequestConfig } from 'app/common/api';

import { TUser } from '../core/user';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_user',
};

type UpdatedUser = Partial<TUser> & { id: number };

export const updateUserRequest = (body: UpdatedUser) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
